export enum COMPLIANCE_RESULT {
    CONTRACT_EXCEEDED = 'CONTRACT_EXCEEDED',
    ACCESSORIES = 'ACCESSORIES',
    DEMO_INELIGIBLE = 'DEMO_INELIGIBLE',
    PRODUCT_WAREHOUSE_MISMATCH = 'PRODUCT_WAREHOUSE_MISMATCH',
    NONE = 'NONE',
}
